import React from "react";
import FleetCertificate from "./views/FleetCertificate";

const App = () => {
    return <FleetCertificate />;
};

export default App;
